'use strict';

// import $ from 'jquery';
namespace model {
	export class data {

		public static isMobile: boolean = false;
		public static mq: string = '';
		public static rootPage: any;

		/**
		 * getter:メディアクエリー
		 */
		public static get modelMq(): string {
			return this.mq;
		}

		/**
		 * setter:メディアクエリー
		 * Triggerイベント:MQ_CHANGE
		 */
		public static set modelMq(value: string) {
			this.mq = value;
			// console.log(`mode(model):${this.modelMq}`);
			$(window).trigger('MQ_CHANGE', [this.modelMq]);
		}
	}
}
export default model;
